import { type LocaleItem } from './types';

export const SupportedLanguage = {
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  pl: 'pl',
  pt: 'pt',
  ru: 'ru',
  uk: 'uk',
} as const;

export type SupportedLanguage = (typeof SupportedLanguage)[keyof typeof SupportedLanguage];

export const DEFAULT_LOCALE_CODE = SupportedLanguage.en;

export const LOCALES: LocaleItem[] = [
  {
    code: SupportedLanguage.de,
    localName: 'Deutsch',
  },
  {
    code: SupportedLanguage.en,
    localName: 'English',
  },
  {
    code: SupportedLanguage.es,
    localName: 'Español',
  },
  {
    code: SupportedLanguage.fr,
    localName: 'Français',
  },
  {
    code: SupportedLanguage.pl,
    localName: 'Polski',
  },
  {
    code: SupportedLanguage.pt,
    localName: 'Português do Brasil',
  },
  {
    code: SupportedLanguage.ru,
    localName: 'Русский',
  },
  {
    code: SupportedLanguage.uk,
    localName: 'Українська',
  },
];

export const LOCALE_CODES = LOCALES.map((locale) => locale.code);

export const LOCALES_MAP = Object.fromEntries(LOCALES.map((locale) => [locale.code, locale]));

export const LOCALE_COOKIE_NAME = 'NEXT_LOCALE';
